import React from "react";

// Admin Imports
import MainDashboard from "./views/admin/default/index.jsx";
import Profile from "./views/admin/profile/index.jsx";
import DataTables from "./views/admin/tables/index.jsx";
import RTLDefault from "./views/rtl/default/index.jsx";

// Auth Imports
import SignIn from "./views/auth/SignIn.jsx";

// View pages

import ViewActivity from "./components/Activity/ViewActivity.jsx";
import ViewIncome from "./components/Income/ViewIncome.jsx";
import ViewNew from "./components/News/ViewNew.jsx";
import ViewNews from "./components/News/ViewNews.jsx";
import ViewBanner from "./components/Banner/ViewBanner.jsx";
import ViewPayment from "./components/Payment/ViewPayment.jsx";
import ViewLoan from "./components/Loan/ViewLoan.jsx";
import AddTrader from "./components/Traders/AddTrader.jsx";
import ViewTraders from "./components/Traders/ViewTrader.jsx";
import ViewInspection from "./components/Inspection/ViewInspection.jsx";
import AddInspection from "./components/Inspection/AddInspection.jsx";
import AddInspectors from "./components/Inspectors/AddInspectors.jsx";
import ViewUser from './components/User/ViewUser.jsx'
// Icon Imports
import {
  MdHome,
  MdPeople,
  MdBarChart,
  MdAttachMoney,
  MdOutlineVideoLibrary,
  MdPhoto,
  MdLock,
} from "react-icons/md";
import { layout } from "@chakra-ui/system";

const routes = [
  {
    name: "Dashboard",
    layout: "/admin",
    path: "default",
    icon: <MdHome className="h-6 w-6" />,
    component: <MainDashboard />,
  },



{

name:"Traders",
layout:"/admin",
path:"/addtrader",
icon:<MdPeople className="h-6 w-6" />,
component:<ViewTraders/>, 

},





  {
    name: "Inspections",
    layout: "/admin",
    submenu: [
      {
        name: "Add Inspection",
        layout: "/admin",
        path: "/AddInspection",
        icon: <MdPeople className="h-6 w-6" />,
        component: <AddInspection />,
      }],
    path: "/viewinspection",
  },


  

  {
    name: "Inspectors",
    layout: "/admin",
    path: "/ViewInspectors",
    icon: <MdPeople className="h-6 w-6" />,
    component: <ViewInspection />,
    submenu: [
      {
        name: "Add Inspection",
        layout: "/admin",
        path: "/AddInspectors",
        icon: <MdPeople className="h-6 w-6" />,
        component: <AddInspectors />,
      }
    ]
  },
  {
    name: "Inspections",
    layout: "/viewinspection",
    path: "loans",
    icon: <MdAttachMoney className="h-6 w-6" />,
    component: <ViewLoan />,
  },


  {
    name: "License",
    layout: "/admin",
    path: "income",
    icon: <MdAttachMoney className="h-6 w-6" />,
    component: <ViewIncome />,
  },
  {
    name: "Inspectos",
    layout: "/admin",
    path: "payments",
    icon: <MdAttachMoney className="h-6 w-6" />,
    component: <ViewPayment />,
  },
  {
    name: "Complaints",
    layout: "/admin",
    path: "viewnews",
    icon: <MdOutlineVideoLibrary className="h-6 w-6" />,
    component: <ViewNews />,
  },
  


  {
    name: "users",
    layout: "/rtl",
    path: "rtl",
    icon: <MdHome className="h-6 w-6" />,
    component: <RTLDefault />,
  },
];
export default routes;
